import React from 'react';

import Urls from '../../../config/index';
import { Link } from 'react-router-dom';
import { message, Table, Tabs, Popconfirm, Button, Modal, Form, Pagination, Row } from 'antd';
import Serach from '../../utils/serach';
import Add from '../../utils/add';
import EditForm from '../../utils/edit';
import Head from '../../utils/head';
const FormItem = Form.Item;

export default class extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            total: 0,
            list: [],
            serach: {},
            page: 1,
            pageSize: 10
        };
        this.onChange = this.onChange.bind(this);
    }
    componentWillMount() {
        
    }

    getList(url) {
        (async (url) => {
            try {
                let response = await fetch(url, {
                    method: 'get',
                    headers: { "Token": "eyJhbGciOiJIUzUxMiJ9.eyJjb20uaWZlbmcuZmxvdy51c2VyLmRvbWFpbi5Vc2VyIjoie1wiY3JlYXRlZFwiOjE1MDM3MTQxNTkwMDAsXCJkZWxldGVkXCI6MCxcImlkXCI6XCI1OTllOGNjZjg4NzEwYjRmZDRlYmM0OTRcIixcIm5hbWVcIjpcImd1Y2hhbmdcIixcInBhc3N3b3JkXCI6XCI2N0MzRjFBOTBBNkIxMDRFRjc2QjM1RDQ1QzhEMjNENlwiLFwicm9sZVwiOjF9In0.mGIFwmBKhdgi1hJ5H5NcsTbgAU7J-Hz7EWWClT73-5oewCXMKCuxEAHRb7nIUpVLZzY_R2J-l1aPbCPfk4nSgg" }
                });
                let pagerForm = await response.json();
                console.log(pagerForm.data.list);
                this.setState(Object.assign(this.state, pagerForm.data))
            } catch (e) {
                console.log(e);
            }
        })(url)
    }

    getListUrl(page, pageSize) {
        return Urls.BrowserUrl.list + "page=" + page + "&pageSize=" + pageSize;
    }

    confirm(record) {
        let url = Urls.BrowserUrl.delete;
        (async (url) => {
            try {
                let response = await fetch(url, {
                    method: 'delete',
                    headers: {
                        "Content-type": "application/json",
                        "Token": "eyJhbGciOiJIUzUxMiJ9.eyJjb20uaWZlbmcuZmxvdy51c2VyLmRvbWFpbi5Vc2VyIjoie1wiY3JlYXRlZFwiOjE1MDM3MTQxNTkwMDAsXCJkZWxldGVkXCI6MCxcImlkXCI6XCI1OTllOGNjZjg4NzEwYjRmZDRlYmM0OTRcIixcIm5hbWVcIjpcImd1Y2hhbmdcIixcInBhc3N3b3JkXCI6XCI2N0MzRjFBOTBBNkIxMDRFRjc2QjM1RDQ1QzhEMjNENlwiLFwicm9sZVwiOjF9In0.mGIFwmBKhdgi1hJ5H5NcsTbgAU7J-Hz7EWWClT73-5oewCXMKCuxEAHRb7nIUpVLZzY_R2J-l1aPbCPfk4nSgg"
                    },
                    body: JSON.stringify(record)
                });
                let result = await response.json();
                if (result.code == 200) {
                    message.success('删除成功');
                    this.getList(this.getListUrl(this.state.page, this.state.pageSize));
                } else {
                    message.error('删除失败:' + result.desc);
                }
            } catch (e) {
                console.log(e);
                message.error('删除失败');
            }
        })(url);
    }

    reset(type) {
        if (type === 'edit') {
            this.getList(this.getListUrl(this.state.page, this.state.pageSize));
        }
        if (type === 'add') {
            this.onChange(parseInt(this.state.total / this.state.pageSize) + 1, this.state.pageSize);
        }
    }

    onChange(current, pageSize) {
        let url = this.getListUrl(current, pageSize);
        this.setState(Object.assign(this.state, { page: current }, { pageSize: pageSize }));
        this.getList(url + "&name=" + (this.state.serach.name ? this.state.serach.name : ""));
    }
    serach(serach) {
        (async (url) => {
            try {
                let response = await fetch(url, {
                    method: 'get',
                    headers: { "Token": "eyJhbGciOiJIUzUxMiJ9.eyJjb20uaWZlbmcuZmxvdy51c2VyLmRvbWFpbi5Vc2VyIjoie1wiY3JlYXRlZFwiOjE1MDM3MTQxNTkwMDAsXCJkZWxldGVkXCI6MCxcImlkXCI6XCI1OTllOGNjZjg4NzEwYjRmZDRlYmM0OTRcIixcIm5hbWVcIjpcImd1Y2hhbmdcIixcInBhc3N3b3JkXCI6XCI2N0MzRjFBOTBBNkIxMDRFRjc2QjM1RDQ1QzhEMjNENlwiLFwicm9sZVwiOjF9In0.mGIFwmBKhdgi1hJ5H5NcsTbgAU7J-Hz7EWWClT73-5oewCXMKCuxEAHRb7nIUpVLZzY_R2J-l1aPbCPfk4nSgg" }
                });
                let pagerForm = await response.json();
                this.state.list = pagerForm.data.list;
                console.log(Object.assign(this.state, pagerForm.data))
                this.setState(Object.assign(this.state, pagerForm.data))
            } catch (e) {
                console.log(e);
                message.error('查询失败');
            }
        })(this.getListUrl(1, 10) + "&name=" + serach.name)
    }

    render() {
        let metadata = [{
            type: 'Input',
            placeholder: '浏览器',
            addonBefore: '名称',
            field: 'name'
        }];
        let addMetas = [{
            type: 'Input',
            placeholder: '名称',
            label: '名称',
            field: 'name'
        }, {
            type: 'Input',
            placeholder: '起始占比',
            label: '起始占比',
            field: 'begin'
        }, {
            type: 'Input',
            placeholder: '结束占比',
            label: '结束占比',
            field: 'end'
        }, {
            type: 'Input',
            placeholder: '类型',
            label: '类型',
            field: 'type'
        }]
        let modify = Urls.BrowserUrl.modify;
        let find = Urls.BrowserUrl.selectById;
        const columns = [{
            title: '名称',
            dataIndex: 'name',
            key: 'name',
        }, {
            title: '占比',
            dataIndex: '',
            render: record => {
                return record.end - record.begin;
            }
        }, {
            title: '操作',
            key: 'action',
            render: record => (
                <span>
                    <EditForm metadata={addMetas} url={modify} find={find + '' + record._id} reset={this.reset.bind(this, 'edit')} />
                    <span className="ant-divider" />
                    <Popconfirm title="是否删除?" onConfirm={this.confirm.bind(this, record)}>
                        <a href="#">删除</a>
                    </Popconfirm>
                </span >
            )
        }];
        return (
            <div >
                <h2>IP重叠</h2>
                <Head serachMeta={metadata} addMeta={addMetas} addUrl={modify} handleSerach={this.serach.bind(this)} />
                <Table columns={columns} dataSource={this.state.list} pagination={false} />
                <Pagination
                    showQuickJumper
                    showSizeChanger
                    total={this.state.total}
                    className='ant-table-pagination'
                    onChange={this.onChange}
                    onShowSizeChange={this.onChange}
                />
            </div>
        );

    }

}




// WEBPACK FOOTER //
// ./components/sider/ip-statistics.js